const cells = new Map<number, HTMLElement>();

export function registerCell(num: number, el: HTMLElement | null) {
  if (el) cells.set(num, el);
  else cells.delete(num);
}

export type CellTarget = { x: number; y: number; size: number };

export function cellTarget(num: number): CellTarget | null {
  const el = cells.get(num);
  if (!el) return null;
  const r = el.getBoundingClientRect();
  if (r.width < 2 || r.height < 2) return null;
  return {
    x: r.left + r.width / 2,
    y: r.top + r.height / 2,
    size: Math.min(r.width, r.height),
  };
}
